import React from 'react'
import LibraryStyle from './Library.module.css'

function Library() {
  return (
    <div className={LibraryStyle.LibraryContainer}>
        {/* <h1>AUDIO BY JMRC</h1> */}
    </div>
  )
}

export default Library